import {
  OwnerOutreachAssembliesResponse,
  OwnerOutreachListResponse,
  OwnerOutreachRow,
  OwnerOutreachStatus,
} from '../types/ownerOutreach';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class OwnerOutreachService {
  private getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('accessToken');
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }

  private async handleResponse<T>(response: Response): Promise<T> {
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(result.message || 'Error en la solicitud');
    }
    return result as T;
  }

  async getAssemblies(complexId?: string): Promise<OwnerOutreachAssembliesResponse> {
    const query = complexId ? `?complexId=${encodeURIComponent(complexId)}` : '';
    const response = await fetch(`${API_BASE_URL}/outreach/assemblies${query}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
    const result = await this.handleResponse<{
      success: boolean;
      data: OwnerOutreachAssembliesResponse;
    }>(response);
    return result.data;
  }

  async listOwners(
    assemblyId: string,
    options?: {
      complexId?: string;
      status?: OwnerOutreachStatus;
      hasActiveDelegation?: boolean;
    }
  ): Promise<OwnerOutreachListResponse> {
    const params = new URLSearchParams();
    if (options?.complexId) params.set('complexId', options.complexId);
    if (options?.status) params.set('status', options.status);
    if (options?.hasActiveDelegation === true) {
      params.set('hasActiveDelegation', 'true');
    } else if (options?.hasActiveDelegation === false) {
      params.set('hasActiveDelegation', 'false');
    }
    const query = params.toString() ? `?${params.toString()}` : '';

    const response = await fetch(
      `${API_BASE_URL}/outreach/assemblies/${assemblyId}/owners${query}`,
      {
        method: 'GET',
        headers: this.getAuthHeaders(),
      }
    );
    const result = await this.handleResponse<{
      success: boolean;
      data: OwnerOutreachListResponse;
    }>(response);
    return result.data;
  }

  async updateOwnerStatus(
    assemblyId: string,
    userId: string,
    payload: { status: OwnerOutreachStatus; notes?: string | null },
    complexId?: string
  ): Promise<OwnerOutreachRow> {
    const query = complexId ? `?complexId=${encodeURIComponent(complexId)}` : '';
    const response = await fetch(
      `${API_BASE_URL}/outreach/assemblies/${assemblyId}/owners/${userId}${query}`,
      {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    const result = await this.handleResponse<{
      success: boolean;
      data: OwnerOutreachRow;
    }>(response);
    return result.data;
  }
}

export const ownerOutreachService = new OwnerOutreachService();
